import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { MaterialModule, } from "jk-service";
import { StktmService, templateUrlConfigStk } from './../_service_stk';
import { Stktm } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stktm-edit',
  templateUrl: templateUrlConfigStk.stktm,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})

export class StktmEditComponent extends JkDialogEditComponent<StktmService, Stktm> {
  override dialogRef: MatDialogRef<StktmEditComponent>;
  override data: jkRestReturn;

  override srv!: StktmService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StktmEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
